import { logout } from "../../../store/slices/authSlice";

export default function responseDeleteAccount(response: any, api: any, arg: any) {
    console.log('delete account response', response);
    if (response?.data) {
        // Log out the user after account deletion
        api.dispatch(logout());
    }
    return response?.data || null;
}